/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'GoalLinker.error.generic.description': 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'GoalLinker.error.generic.header': 'Etwas ist schiefgelaufen',
  'GoalLinker.error.linking.header': 'Ziel konnte nicht verknüpft werden',
  'GoalLinker.error.max-entities-to-goal.description':
    'Es können maximal 100 {entities} mit einem Ziel verknüpft werden. Entfernen Sie bitte eine {entity}, wenn Sie weitere {entities} verknüpfen möchten.',
  'GoalLinker.error.max-entities-to-goal.header': 'Limit von 100 {entity} erreicht',
  'GoalLinker.error.max-goals.description':
    'Es können maximal 100 Ziele verknüpft werden. Bitte entfernen Sie zuerst einige verknüpfte Ziele, wenn Sie weitere Ziele verknüpfen möchten.',
  'GoalLinker.error.max-goals.header': 'Limit von 100 Zielen erreicht',
  'GoalLinker.goal-row.open-goal': 'Ziel öffnen',
  'GoalLinker.link-goals.error-description':
    'Etwas ist schiefgelaufen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'GoalLinker.link-goals.error-title': 'Verknüpfung des Ziels konnte nicht aufgehoben werden',
  'GoalLinker.linked-goals.header': 'Verknüpfte Ziele',
  'GoalLinker.linked-goals.show-less': 'Weniger anzeigen',
  'GoalLinker.linked-goals.show-more': '{count} weitere anzeigen',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Ideen mit Zielen verknüpfen, um nachzuverfolgen, wie sich die Arbeit auf Ergebnisse auswirkt',
  'GoalLinker.recents.emptystate-project.description':
    'Projekte mit Zielen verknüpfen, um zu verfolgen, wie durch die Arbeit Ergebnisse erzielt werden',
  'GoalLinker.recents.emptystate.description':
    'Vorgänge mit Zielen verknüpfen, um zu verfolgen, wie durch die Arbeit Ergebnisse erzielt werden',
  'GoalLinker.recents.emptystate.header': 'Erste Schritte mit Zielen',
  'GoalLinker.recents.header': 'Letzte Ziele',
  'GoalLinker.search.emptystate.description': 'Nach Tippfehlern suchen',
  'GoalLinker.search.emptystate.header': 'Keine passenden Ergebnisse',
  'GoalLinker.search.label': 'Ergebnisse',
  'GoalLinker.search.placeholder': 'Ziele suchen oder Link einfügen',
};
